import { QueryKey, useQuery } from "@tanstack/react-query";
import { produce } from "immer";

import { GraphQLAPI, queries } from "@examspark/api";
import {
  ParsedSearchableResourceConnectionNew,
  QuerySearchArgs,
  SearchableResourceFilterInput,
} from "@examspark/types";

import { useAuthorizationContext } from "../../hooks/useAuthorizationContext";
import { useAppContext } from "../../providers/AppContext";

export const useQuerySearchRevisionNotes = (props: {
  queryKey: QueryKey;
  filter?: SearchableResourceFilterInput;
}) => {
  const authorizationContext = useAuthorizationContext();
  const [state] = useAppContext();

  const filter: SearchableResourceFilterInput = {
    and: [
      {
        sk: {
          wildcard: `revision-note*`,
        },
      },
    ],
  };

  if (props.filter != null) {
    filter.and?.push(props.filter);
  }

  const variables: QuerySearchArgs = {
    authorizationContext,
    filter,
  };

  return useQuery({
    enabled: !!state.workspaceUser?.id,
    queryKey: props.queryKey,
    // add a name for our browse list to use
    // TODO: better synthesize this
    select: (data) => {
      return produce(data, (draft) => {
        draft.items = draft?.items?.map((item) => {
          return {
            ...item,
            name: item?.description?.substring(0, 50),
          };
        });

        draft.aggregations =
          typeof draft.aggregations === "string"
            ? JSON.parse(draft.aggregations)
            : draft.aggregations;
      });
    },
    queryFn: async () =>
      (
        (await GraphQLAPI.query({
          query: queries.search.search({
            label: "SearchRevisionNotes",
            fields: `
              id
              sk
              description
              type
              workspaceId
              bankId
              idInc
              createdAt
              updatedAt
              subject
              resourceId
              resource {
                id
                sk
                name
              }
              createdAt
              updatedAt
            `,
          }),
          variables,
        })) as any
      ).data.search as ParsedSearchableResourceConnectionNew,
  });
};
